/* ============================================================
   PetJojo — fold the announcement bar on scroll (phones only)
   ------------------------------------------------------------
   The bar and the header are BOTH sticky (their section wrappers are
   position:sticky at top:0 and top:var(--pj-bar-h)), so together they hold 127px
   of a phone screen permanently. This folds the bar away as the shopper reads
   down the page and brings it back when they scroll back up.

   It only toggles a class; the collapse itself is CSS (custom.css), and the
   header's sticky offset needs no work here — a script in header-group.json
   already keeps --pj-bar-h in sync with the bar's measured height through a
   ResizeObserver, so when the bar collapses the header slides up to meet it.

   Desktop is untouched: there the bar is a single 47px line and the pair is not
   crowding anything.
   ============================================================ */
(function () {
  var MQ = window.matchMedia('(max-width: 767px)');
  var FOLDED = 'pj-bar-folded';
  /* Ignore sub-threshold movement so a shaky thumb, or the rubber-band at the
     top of iOS, doesn't flap the bar open and shut. */
  var THRESHOLD = 8;
  /* Near the top the bar is always shown, whichever way the last scroll went —
     otherwise it stays hidden after you scroll back to the very top. */
  var TOP_ZONE = 40;

  /* Long enough to outlast the 260ms max-height transition in custom.css. */
  var SETTLE = 320;

  var root = document.documentElement;
  var last = window.scrollY || 0;
  var settleTimer = null;

  /* .shopify-section prefix matters: the bare id-suffix selector also matches
     elements INSIDE the section, whose ids end in the same section id. */
  function getBar() {
    return document.querySelector('.shopify-section[id$="__announcement-bar"]');
  }

  function clearClamp(bar) {
    bar.style.maxHeight = '';
    bar.style.opacity = '';
  }

  /* Only write when the state actually changes, so a scroll does not invalidate
     styles on every event.

     max-height is the only thing that animates a collapse to nothing, but it
     needs a real pixel number to ease between and the bar has no fixed height —
     62px at two lines, 77px at three, and the copy can change. It is measured
     here, per animation, rather than kept clamped on the open bar: a clamp that
     outlives the animation crops the bar's bottom padding the moment the
     measurement is short by even a pixel (a webfont swapping in late is enough),
     and that is not self-correcting. Measured fresh at the start of each fold
     and dropped again once the bar is open, a short reading costs at most one
     slightly-off animation and nothing at rest.

     scrollHeight, not getBoundingClientRect(): the rect reports the height the
     element is currently CLAMPED to — 0 while folded — where scrollHeight
     reports the content's real height either way, which is what unfolding needs
     to ease towards. */
  function setFolded(on) {
    if (root.classList.contains(FOLDED) === on) return;
    var bar = getBar();
    if (!bar) return;

    if (settleTimer) {
      clearTimeout(settleTimer);
      settleTimer = null;
    }

    /* Folding, this is the from-value the ease starts at (the open bar has no
       max-height of its own). Unfolding, it is the target — the from-value is
       the 0px left inline by the fold. Reading offsetHeight flushes the style
       change so the browser has a value to animate from rather than coalescing
       both writes into one. */
    bar.style.maxHeight = bar.scrollHeight + 'px';
    bar.offsetHeight;

    if (on) {
      bar.style.maxHeight = '0px';
      bar.style.opacity = '0';
    } else {
      bar.style.opacity = '1';
      /* Once open, drop the clamp so the bar sizes to its own content again and
         cannot be cropped by a stale number. */
      settleTimer = setTimeout(function () {
        settleTimer = null;
        if (!root.classList.contains(FOLDED)) clearClamp(bar);
      }, SETTLE);
    }

    root.classList[on ? 'add' : 'remove'](FOLDED);
  }

  /* Deliberately NOT rAF-throttled. This reads window.scrollY only — no layout
     is forced — and the class is written just on a state change, so running it
     per scroll event is cheap. rAF would also stall wherever frames are paused
     (a background tab), leaving the bar stuck in whichever state it was in. */
  function apply() {
    var y = window.scrollY || 0;

    if (!MQ.matches) {
      setFolded(false);
      last = y;
      return;
    }

    if (y <= TOP_ZONE) {
      setFolded(false);
      last = y;
      return;
    }

    var dy = y - last;
    // Below the threshold, leave `last` alone so small moves accumulate rather
    // than being swallowed one event at a time.
    if (Math.abs(dy) < THRESHOLD) return;

    setFolded(dy > 0);
    last = y;
  }

  window.addEventListener('scroll', apply, { passive: true });

  function onBreakpoint() {
    /* Crossing to desktop, strip the inline clamp immediately instead of
       letting apply() unfold through the animation — the CSS that collapses the
       bar is phone-only, so there is nothing to ease and an inline max-height
       left behind would be a crop waiting to happen at a desktop width. */
    if (!MQ.matches) {
      var bar = getBar();
      if (bar) clearClamp(bar);
    }
    apply();
  }
  if (MQ.addEventListener) MQ.addEventListener('change', onBreakpoint);
  else if (MQ.addListener) MQ.addListener(onBreakpoint);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onBreakpoint, { once: true });
  } else {
    onBreakpoint();
  }
})();
